export default class {

    constructor() {}

    //default validation
    //strings
    validate_array(str_array,error_msg){
        let process_errors = [];

        //default testers
        let reg_num = /^[0-9]+$/;
        let reg_name = /^[\w\-\s]+$/;
        let reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let reg_phone = /^\d{4}\d{3}\d{4}$/;

        for(var i = 0; i < str_array.length; i++) { //rows
            var arr_in_str_array = str_array[i]; //initialising the individual array row in str_array //row
           // for(var j = 0; j < arr_in_str_array.length; j++) { ///looping through the individual array //columns in row
                if(arr_in_str_array[1] == undefined || arr_in_str_array[1] == ""){
                    process_errors.push(error_msg+arr_in_str_array[0]);

                    //only alpha test
                    if(arr_in_str_array[2] == "alpha"){
                        if(!(reg_name.test(arr_in_str_array[1]))){
                            process_errors.push(arr_in_str_array[0]+" is not valid");
                        }
                    }

                    //only number test
                    if(arr_in_str_array[2] == "num"){
                        if(!(reg_num.test(arr_in_str_array[1]))){
                            process_errors.push(arr_in_str_array[0]+" is not valid");
                        }
                    }

                    //email test
                    if(arr_in_str_array[2] == "email"){
                        if(!(reg_email.test(String(arr_in_str_array[1]).toLowerCase()))){
                            process_errors.push(arr_in_str_array[0]+" is not valid");
                        }
                    }

                    //phone test
                    if(arr_in_str_array[2] == "phone"){
                        if(!(reg_phone.test(arr_in_str_array[1]))){
                            process_errors.push(arr_in_str_array[0]+" is not valid");
                        }
                    }

                    //date test

                    //datetime test

                    
                }

                //tester test
                //display("row[" + i + "][" + j + "] = " + arr_in_str_array[j]);
           // }
        }
        
        return process_errors;
        

        // if(item.order_delivery_address == undefined || item.order_delivery_address == ""){
        //     process_errors.push("Please enter delivery address for "+item.product_name);
        // }
        // if(item.order_delivery_name == undefined || item.order_delivery_name == ""){
        //     process_errors.push("Please enter delivery Name for "+item.product_name);
        // }
        // if(item.order_delivery_phone == undefined || item.order_delivery_phone == ""){
        //     process_errors.push("Please enter delivery Phone Number for "+item.product_name);
        // }
        // if(phone_test == false){
        //     process_errors.push("Use format (09077665544) for "+item.product_name+" 's Phone Number ");
        // }
        // if(item.order_delivery_email == undefined || item.order_delivery_email == ""){
        //     process_errors.push("Please enter delivery Email for "+item.product_name);
        // }
        // if(email_test == false){
        //     process_errors.push("Email seems incorrect for "+item.product_name+" 's Email ");
        // }
        // if(item.order_delivery_words == undefined || item.order_delivery_words == ""){
        //     process_errors.push("Please enter delivery Gift Message for "+item.product_name);
        // }
    }
    //for all form validation
        
    //email
    validateEmail(email){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    //alphabets names inputs
    validateName(name){ 
        let re = /^[\w\-\s]+$/;
        return re.test(name);
    }
    //phone number nigeria format
    validatePhoneNumber(phone){ 
        let re = /^\d{4}\d{3}\d{4}$/;
        return re.test(phone);
    }

    //website 
    validateWebsite(url){ 
        //let re = /^(ftp|http|https):\/\/[^ "]+$/;
        //let re = /^((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/;
        let re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
        return re.test(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/validation.js